import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getDealershipUserInfo } from "../services/dealership-user";
import { useDealershipContext } from "../contexts/dealershipContext";

export function useGetDealershipUserInfo(
  userId,
  openedThroughEmail,
  setQuizIndexMapping,
  setUser,
  setInventoryMatches,
  setMaeTrimsMatches,
  setResponseError,
  setResponseMessage,
  setRequestPending,
  setUserId,
  setOpenedThroughEmail
) {
  const { dealershipId } = useDealershipContext();
  const location = useLocation();

  const checkUserId = () => {
    const searchString = window.location.search;
    const params = new URLSearchParams(searchString);
    setUserId(params.get("id") || null);
    setOpenedThroughEmail(params.get("email") || "0");
    return [
      params.get("id"),
      setOpenedThroughEmail(params.get("email") || "0"),
    ];
  };

  useEffect(() => {
    setRequestPending(true);
    const paramDetails = !userId ? checkUserId() : null;
    const currentUserId = userId || paramDetails[0];
    const currentOpenedThroughEmailStatus =
      openedThroughEmail || paramDetails[1];
    if (!currentUserId) {
      setRequestPending(false);
      return;
    }
    const getUserInfo = async () => {
      try {
        const {
          inventoryMatches,
          maeTrimsMatches,
          user,
          quizIndexMapping,
          message,
          error,
        } = await getDealershipUserInfo(
          currentUserId,
          currentOpenedThroughEmailStatus,
          dealershipId
        );
        setInventoryMatches(inventoryMatches);
        setQuizIndexMapping(quizIndexMapping);
        setMaeTrimsMatches(maeTrimsMatches);
        setUser(user);
        setResponseMessage(message);
        setResponseError(error);
      } catch (error) {
        console.log(error);
        setInventoryMatches([]);
        setMaeTrimsMatches([]);
        setUser({});
        setQuizIndexMapping({});
        setResponseMessage("Bad Request");
        setResponseError(error);
      } finally {
        setRequestPending(false);
      }
    };
    getUserInfo();
  }, [userId, location.pathname]);
}
